// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4041":"097d3182b141117e","9437":"50daae237a6c5680"}[chunkId] + ".js";
};